"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isObject = _interopRequireDefault(require("lodash/fp/isObject"));

var _Checkbox = _interopRequireDefault(require("../checkbox/Checkbox"));

var _RadioButton = _interopRequireDefault(require("../radiobutton/RadioButton"));

var TreeLeaf = /*#__PURE__*/_react.default.memo(function (props) {
  var item = props.item,
      hasMultiselect = props.hasMultiselect,
      showRadioButtons = props.showRadioButtons,
      isSelected = props.isSelected,
      onSelectItem = props.onSelectItem,
      onActiveItem = props.onActiveItem;
  var treeNodeClassNames = (0, _classnames.default)('TreeLeaf', 'from-group', isSelected && 'active', item.className && item.className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: treeNodeClassNames,
    "data-key": item.id
  }, hasMultiselect && /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    className: 'TreeCheckbox',
    checked: isSelected,
    onClick: onSelectItem
  }), !hasMultiselect && showRadioButtons && /*#__PURE__*/_react.default.createElement(_RadioButton.default, {
    className: 'TreeRadioButton',
    checked: isSelected,
    onChange: onSelectItem
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: 'TreeLabel',
    onClick: onActiveItem
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'TreeLabelName'
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "rioglyph rioglyph-".concat(item.type)
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: 'TreeLabelNameText'
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'TreeLabelNameTextHeadline'
  }, (0, _isObject.default)(item.name) ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: 'text-light margin-right-3'
  }, item.name.firstName), /*#__PURE__*/_react.default.createElement("span", null, item.name.lastName)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, item.name)), item.info && /*#__PURE__*/_react.default.createElement("span", {
    className: 'TreeLabelNameTextSubline'
  }, item.info)))));
});

TreeLeaf.displayName = 'TreeLeaf';
TreeLeaf.defaultProps = {};
TreeLeaf.propTypes = {
  item: _propTypes.default.object,
  hasMultiselect: _propTypes.default.bool,
  showRadioButtons: _propTypes.default.bool,
  isSelected: _propTypes.default.bool,
  onSelectItem: _propTypes.default.func,
  onActiveItem: _propTypes.default.func
};
var _default = TreeLeaf;
exports.default = _default;